import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

const paymentOptions = [
  { label: "Bank", value: 1 },
  { label: "Cash", value: 2 },
  { label: "Card", value: 3 },
  { label: "Online", value: 4 },
];

// Validation schema using Yup
const validationSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  phoneNumber: Yup.string()
    .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
    .required("Phone number is required"),
  address: Yup.string(),
  type: Yup.number().required("Payment type is required"),
  remarks: Yup.string(),
});

const PaymentModal = ({ isOpen, toggle, onSubmit, loading }) => {
  const formik = useFormik({
    initialValues: {
      phoneNumber: "",
      address: "",
      name: "",
      type: 2, // Default to Cash
      remarks: "",
      printBill: false,
    },
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      onSubmit(values);
      resetForm();
      toggle();
    },
  });

  const resetModal = () => {
    formik.resetForm();
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={resetModal}>
      <form onSubmit={formik.handleSubmit}>
        <ModalHeader toggle={toggle}>Payment Details</ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <label className="form-label">Name</label>
            <input
              type="text"
              className={`form-control ${
                formik.touched.name && formik.errors.name ? "is-invalid" : ""
              }`}
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.name && formik.errors.name && (
              <div className="invalid-feedback">{formik.errors.name}</div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">Phone Number</label>
            <input
              type="tel"
              className={`form-control ${
                formik.touched.phoneNumber && formik.errors.phoneNumber
                  ? "is-invalid"
                  : ""
              }`}
              name="phoneNumber"
              value={formik.values.phoneNumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.phoneNumber && formik.errors.phoneNumber && (
              <div className="invalid-feedback">
                {formik.errors.phoneNumber}
              </div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">Address</label>
            <input
              type="text"
              className="form-control"
              name="address"
              value={formik.values.address}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Payment Type</label>
            <select
              className={`form-select ${
                formik.touched.type && formik.errors.type ? "is-invalid" : ""
              }`}
              name="type"
              value={formik.values.type}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              {paymentOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {formik.touched.type && formik.errors.type && (
              <div className="invalid-feedback">{formik.errors.type}</div>
            )}
          </div>

          <div className="mb-3">
            <label className="form-label">Remarks</label>
            <textarea
              className="form-control"
              name="remarks"
              value={formik.values.remarks}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              rows="2"
            />
          </div>
          <div className="mb-3 form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="printBill"
              name="printBill"
              checked={formik.values.printBill}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            <label className="form-check-label" htmlFor="printBill">
              Print Bill
            </label>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={resetModal}>
            Cancel
          </Button>
          <Button color="success" type="submit" disabled={loading}>
            {loading ? "Processing..." : "Confirm Payment"}
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default PaymentModal;
